<aside
  class="fixed lg:relative inset-y-0 left-0 transform lg:transform-none transition-transform duration-300 ease-in-out w-auto min-w-[250px] py-5 lg:py-10 px-2 lg:px-5 h-full flex flex-col shadow-lg lg:shadow-none z-50 bg-white lg:!bg-transparent"
  [ngClass]="{
    'lg:translate-x-0': true,
  }">
  <div class="w-full h-full flex flex-col justify-between">
    <div class="flex flex-col gap-2">
      <div class="flex gap-3 justify-between">
        <img [src]="ImagesConfig.logo.src" [alt]="ImagesConfig.logo.alt" />
      </div>

      <div class="w-full flex flex-col mt-5 gap-2">
        @for (item of MenuItems; track item) {
          <qaroni-menu-item
            class="w-full"
            [item]="item"
            (closeMenu)="close()"></qaroni-menu-item>
        }
      </div>
    </div>

    <div class="w-full flex flex-col mt-5 gap-2">
      @if (account$ | async) {
        <button
          (click)="profile()"
          class="flex flex-col justify-center items-center gap-3 rounded-full text-sm leading-5 cursor-pointer outline-none">
          <img
            class="rounded-full w-[48px] h-[48px]"
            [src]="account?.image ? account?.image : ImagesConfig.avatar.src"
            [alt]="ImagesConfig.avatar.alt" />
        </button>
      }

      <a
        class="qaroni-btn qaroni-button-item-menu qaroni-button-item-logout"
        [routerLink]="['/auth/logout']">
        <mat-icon>exit_to_app</mat-icon>
        <span>Salir</span>
      </a>
    </div>
  </div>
</aside>
